export const GetOrders_REQUEST = "GetOrders_REQUEST";
export const GetOrders_SUCCESS = "GetOrders_SUCCESS";
export const GetOrders_FAIL = "GetOrders_FAIL";

export const AddOrder_REQUEST = "AddOrders_REQUEST";
export const AddOrder_SUCCESS = "AddOrders_SUCCESS";
export const AddOrder_FAIL = "AddOrders_FAIL";

export const AddOrderItem_REQUEST = "AddOrderItem_REQUEST";
export const AddOrderItem_SUCCESS = "AddOrderItem_SUCCESS";
export const AddOrderItem_FAIL = "AddOrderItem_FAIL";

export const GetOrderItems_REQUEST = "GetOrderItems_REQUEST";
export const GetOrderItems_SUCCESS = "GetOrderItems_SUCCESS";
export const GetOrderItems_FAIL = "GetOrderItems_FAIL";

export const UpdateStatusOrder_REQUEST = "UpdateStatusOrder_REQUEST";
export const UpdateStatusOrder_SUCCESS = "UpdateStatusOrder_SUCCESS";
export const UpdateStatusOrder_FAIL = "UpdateStatusOrder_FAIL";


export const UpdateStatusOrderItem_REQUEST = "UpdateStatusOrderItem_REQUEST";
export const UpdateStatusOrderItem_SUCCESS = "UpdateStatusOrderItem_SUCCESS";
export const UpdateStatusOrderItem_FAIL = "UpdateStatusOrderItem_FAIL";


export const GetOrderItemByID_REQUEST = "GetOrderItemByID_REQUEST";
export const GetOrderItemByID_SUCCESS = "GetOrderItemByID_SUCCESS";
export const GetOrderItemByID_FAIL = "GetOrderItemByID_FAIL";


export const PayAdvance_REQUEST = "PayAdvance_REQUEST";
export const PayAdvance_SUCCESS = "PayAdvance_SUCCESS";
export const PayAdvance_FAIL = "PayAdvance_FAIL";